import { Button } from "@/atoms-react/button/Button.react.tsx";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react.tsx";
import { RadioCard } from "@/atoms-react/radio-card/index.react.tsx";
import { Base, SectionTitleSmall } from "@/atoms-react/text/Text.react.tsx";
import type { ModalIbanAccountStep, QuizStepProps } from "@/features/user/quiz/types.ts";
import { Themes } from "@/types/theme.ts";
import { useState } from "react";
import { useTranslation } from "react-i18next";

enum ModalRadiosTransKeys {
  YesCommunicate = "yes",
  Nope = "no"
}
export const CheckCommercialRegisterStep = ({
  setStep,
  quizResponses,
  setQuizResponses,
  stepSettings,
  setPrevStep,
  totalSteps = 8
}: QuizStepProps) => {
  const { t } = useTranslation(["pass"]);
  const [loading, _setLoading] = useState(false);
  const handleRadioBoxChange = (selectedOption) =>
    setQuizResponses?.((prev) => ({
      ...prev,
      check_register: { ...prev.check_register, trans_key: selectedOption }
    }));
  const isQuizAnswered = () => {
    if (!quizResponses?.check_register || Object.keys(quizResponses?.check_register).length === 0) {
      return false;
    }
    if (quizResponses?.check_register?.trans_key === null) {
      return false;
    }
    return true;
  };
  return (
    <>
      <SectionTitleSmall className="mt-2 mb-4 block">
        {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.check_register.question")}
      </SectionTitleSmall>
      <div className="my-4 mt-auto w-full space-y-4">
        {[ModalRadiosTransKeys.YesCommunicate, ModalRadiosTransKeys.Nope].map((m) => (
          <RadioCard
            active={
              (quizResponses?.check_register &&
                quizResponses?.check_register?.trans_key === m) as boolean
            }
            key={m}
            onClick={() => handleRadioBoxChange(m)}
          >
            <Base>
              {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.check_register.responses." + m)}
            </Base>
          </RadioCard>
        ))}
      </div>
      <div className="mt-auto mb-4 flex flex-col items-center">
        <DotsNavigation total={totalSteps + 3} current={stepSettings.current} className="mb-4" />
        <div className="flex w-full flex-col-reverse gap-y-2 md:flex-row md:gap-x-2">
          <Button
            theme={Themes.white}
            onClick={() => setPrevStep(stepSettings.previous as ModalIbanAccountStep)}
          >
            {t("olkypass.general.go_back")}
          </Button>

          <Button
            disabled={!isQuizAnswered()}
            loading={loading}
            onClick={() => setStep(stepSettings.next as ModalIbanAccountStep)}
          >
            {t("olkypass.general.continue")}
          </Button>
        </div>
      </div>
    </>
  );
};
